import { storeToRefs } from 'pinia';
const useWhenTenantReady = async <T>(callback: () => T) => {
    const { tenant } = storeToRefs(useAuthStore());

    if (tenant.value) {
        await callback();
        return;
    }

    const stopWatching = watch(tenant, async (newValue) => {
        if (!newValue) {
            return;
        }

        try {
            await callback();
        } catch (error) {
        } finally {
            stopWatching();
        }
    });
};

export default useWhenTenantReady;
